import { GoogleMapsLoaderService } from './services/google-maps-loader.service';

export function initializeGoogleMaps(googleMapsLoader: GoogleMapsLoaderService) {
  return (): Promise<void> => {
    return googleMapsLoader.loadGoogleMaps();
  };
}
